<template>
  <v-footer>
    <div class="flex-grow-1"></div>
    <div>Livepaow &copy; {{ new Date().getFullYear() }}</div>
  </v-footer>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>

<style scoped>

</style>
